import * as React from "react";
import NavigationBar from "./navigation";
import LinkedIn from "./socials/linkedin";
import Email from "./socials/email";
import Phone from "./socials/phone";
import FooterLink from "./footerlink";
import { translations, type Language, type Translations } from "../localization";

export const LanguageContext = React.createContext<{
  lang: Language;
  setLang: (lang: Language) => void;
  translations: Translations;
}>({
  lang: "en",
  setLang: () => {},
  translations,
});
const Layout = ({ children }: { children: any }) => {
  const [lang, setLang] = React.useState<Language>(() => {
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const langParam = params.get("lang");
      if (langParam === "en" || langParam === "de") {
        return langParam;
      }
    }
    return "en";
  });
  
  const handleLangChange = (newLang: Language) => {
    setLang(newLang);
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("lang", newLang);
      window.history.replaceState({}, "", url.toString());
    }
  };
  
  return (
    <LanguageContext.Provider value={{ lang, setLang: handleLangChange, translations }}>
      <div id="top" className="site-bg flex min-h-screen flex-col">
      <header className="fixed top-0 z-50 flex h-[82px] w-full flex-col justify-center bg-main md:sticky md:bg-main/60 md:backdrop-blur-md">
        <div className="h-[2px] w-full bg-tertiary" />
        <div className="flex h-20 w-full flex-row justify-center">
          <NavigationBar />
        </div>
      </header>
      <main className="flex flex-grow flex-col items-center pt-[82px] md:pt-0">{children}</main>
      <footer className="flex h-fit w-full flex-col">
        <div className="h-[2px] w-full bg-tertiary" />
        <div className="flex w-full flex-col px-4 py-6 md:p-8">
          <div className="mx-auto grid w-fit grid-cols-1 grid-rows-1 content-start items-start justify-items-start gap-4 md:w-full md:max-w-7xl md:grid-cols-[1fr_auto_1fr]">
            <div className="hidden h-full w-full content-center justify-start md:flex">
              <ul className="flex flex-col">
                <li>IT-Consulting Julian Ewers-Peters</li>
                <li>Brunnenstra&szlig;e 4</li>
                <li>49214 Bad Rothenfelde</li>
              </ul>
            </div>
            <div className="flex h-full w-auto content-center justify-center">
              <ul className="mx-auto flex h-full flex-row content-start items-center space-x-4">
                <li>
                  <Phone className="h-8 w-8 fill-primary transition duration-200 ease-in-out hover:scale-125 hover:fill-highlight md:h-10 md:w-10" />
                </li>
                <li>
                  <Email className="h-8 w-8 fill-primary transition duration-200 ease-in-out hover:scale-125 hover:fill-highlight md:h-10 md:w-10" />
                </li>
                <li>
                  <LinkedIn className="h-8 w-8 fill-primary transition duration-200 ease-in-out hover:scale-125 hover:fill-highlight md:h-10 md:w-10" />
                </li>
              </ul>
            </div>
            <div className="flex h-full w-full content-center justify-end">
              <ul className="flex h-full flex-row items-center space-x-2 md:flex-col md:items-end md:space-x-0 md:space-y-2">
                <li>
                  <FooterLink title={translations[lang].footerPrivacy} link="/privacy#top" />
                </li>
                <li className="md:hidden">•</li>
                <li>
                  <FooterLink title={translations[lang].footerImprint} link="/imprint#top" />
                </li>
                <li className="md:hidden">•</li>
                <li>
                  <button
                    className="h-6 w-auto px-1 rounded-md flex items-center justify-center transition duration-200 ease-in-out hover:scale-110 border-[1.5px] border-primary hover:border-highlight bg-transparent md:h-7.5 md:px-1.5"
                    onClick={() => handleLangChange(lang === "en" ? "de" : "en")}
                    aria-label="Switch language"
                    title={lang === "en" ? "Switch to German" : "Switch to English"}
                  >
                    <span className="text-primary font-semibold text-[0.7rem] md:text-xs">
                      {lang === "en" ? "EN" : "DE"}
                    </span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </LanguageContext.Provider>
  );
};

export default Layout;
